import React, {useState, useEffect} from 'react';
import 'fontsource-roboto';
import {makeStyles} from '@material-ui/core/styles';
import useIsMountedRef from './../Components/useIsMountedRef';
import {Link} from 'react-router-dom';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import CardContent from '@material-ui/core/CardContent';
import Fab from '@material-ui/core/Fab';

import SearchIcon from '@material-ui/icons/Search';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import AddIcon from '@material-ui/icons/Add';

import Warning from '../Components/Warning';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: theme.spacing(0.5)
  },
  cardHeader: {
    padding: theme.spacing(1, 2, 1)
  },
  avatarPrimary: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main
  },
  avatarSecondary: {
    color: theme.palette.secondary.contrastText,
    backgroundColor: theme.palette.secondary.main
  },
  cardContent: {
    flexGrow: 1,
    padding: theme.spacing(1),
    '&:last-child': {
      paddingBottom: theme.spacing(1)
    }
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2)
  },
  fabIcon: {
    marginRight: theme.spacing(1)
  }
}));

export default function Patients(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [isLoaded, setIsLoaded] = useState(false);
  const [filter, setFilter] = useState({
    text: ''
  });
  const [data, setData] = useState([]);

  useEffect(() => {
    setIsLoaded(false);
    ajax('resellerPatients')
      .then(response => {
        if (!isMountedRef.current) return;

        if (response.ok)
          setData(response.data)
        setIsLoaded(true);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleFilterChange = e => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value !== null ? e.target.value : ''
    });
  };

  const filterData = item => true
      && (
           !!~item.surname.toLowerCase().indexOf(filter.text.toLowerCase())
        || !!~item.name.toLowerCase().indexOf(filter.text.toLowerCase())
        || !!~item.cnp.toLowerCase().indexOf(filter.text.toLowerCase())
      );

  return (
    <Container maxWidth='md'>
      <Typography variant='h6'>Pacienti</Typography>
      <Typography variant='subtitle2'>Sunt afisati toti pacientii care au avut probe recoltate pana in prezent.</Typography>
      <Typography variant='subtitle2'>Selectati un client pentru a vizualiza toate recoltarile pentru care avem rezultate validate din partea laboratorului.</Typography>
      <Typography variant='caption'>Daca lista devine destul de mare si creste timpul de incarcare al paginii, va trebui sa facem un modul de cautare.</Typography>
      <Divider className={classes.divider} />

      {!isLoaded &&
        <Box display='block' align='center'>
          <CircularProgress />
        </Box>
      }

      {isLoaded && data.length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda conditiilor cerute.</Warning>
      }

      {isLoaded && data.length > 0 &&
        <Grid container>
          <Grid item xs={12}>
            <TextField margin='none' autoComplete='off'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              label='Filtrare rapida'
              placeholder='Filtrare rapida'
              name='text'
              value={filter.text}
              onChange={handleFilterChange}
            />
          </Grid>
        </Grid>
      }

      {isLoaded && data.length > 0 && data.filter(filterData).length === 0 &&
        <Warning variant='subtitle2' align='center'>Nu exista nici o inregistrare care sa corespunda filtrelor aplicate.</Warning>
      }

      {isLoaded &&
        <Grid container spacing={1} alignItems='stretch'>
          {data.filter(filterData).map(item =>
            <Grid key={item.id} item xs={12} sm={6} md={4} style={{display: 'flex'}}>
              <Link to={`Results/${item.cnp}`} className={classes.link} style={{flexGrow: 1}}>
                <Card className={classes.card}>
                  <CardHeader className={classes.cardHeader}
                    avatar={
                      <Avatar className={classes.avatarPrimary}>
                        <PeopleAltIcon />
                      </Avatar>
                    }
                    title={`${item.surname} ${item.name}`}
                    subheader={`CNP: ${item.cnp}`}
                  />
                  <CardContent className={classes.cardContent}>
                    <Typography color='textSecondary'>Telefon: {item.phone}</Typography>
                    <Typography color='textSecondary'>Recoltari: {item.receptionsCount}</Typography>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          )}
        </Grid>
      }

      {isLoaded && !!~props.user.permissions.indexOf('partnerAddReception') &&
        <Link to='/AddReception' className={classes.link}>
          <Fab variant='extended' className={classes.fab}>
            <AddIcon className={classes.fabIcon} />
            Adauga recoltare
          </Fab>
        </Link>
      }
    </Container>
  );
}